// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"AppBar_mainHeader__1lH5d"};